<template>
  <div class='Box'>
    <el-card class="box-card">
      <el-form :model="queryParams" size="medium" label-width="100px" class="mt35">
        <el-row :gutter="35">
          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="主体ID">
              <el-input v-model="queryParams.id" @change="search" placeholder="请输入主体名称"
                        clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="主体名称">
              <el-input v-model="queryParams.name" @change="search" placeholder="请输入主体名称"
                        clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="合作类型">
              <el-select v-model="queryParams.cooperate_type" filterable @change="search" placeholder="请选择合作类型" clearable class="w100">
                <el-option v-for="item in typeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="状态">
              <el-select v-model="queryParams.status" placeholder="请选择状态" @change="search" clearable style="width: 100%;">
                <el-option label="正常" :value="1"></el-option>
                <el-option label="禁用" :value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <div class="btn_left">
              <el-button type="primary" size="medium" @click="search">查询</el-button>
              <el-button @click="addNoNe" size="medium">重置</el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <div class="div_buttom">
        <el-button size="medium" @click="addNoNe">刷新列表</el-button>
        <el-button size="medium" type="primary" icon="el-icon-plus" @click="addList">添加</el-button>
      </div>
      <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%"
                size="medium"
                :header-cell-style="{textAlign:'center',background:'#f5f7fa'}" :cell-style="{textAlign:'center'}"
                @selection-change="handleSelectionChange" border v-loading="loading">
        <el-table-column label="主体ID">
          <template slot-scope="scope">{{ scope.row.id }}</template>
        </el-table-column>

        <el-table-column prop="name" label="营业执照" width="120">
          <template slot-scope="scope">
            <el-image
                style="width: 80px; height: 80px"
                :src="scope.row.license_full"
                :preview-src-list="[scope.row.license_full]"
                fit="cover">
            </el-image>
          </template>
        </el-table-column>

        <el-table-column prop="name" label="主体名称">
          <template slot-scope="scope">{{ scope.row.name }}</template>
        </el-table-column>

        <el-table-column prop="name" label="统一社会信用代码">
          <template slot-scope="scope">{{ scope.row.credit_code }}</template>
        </el-table-column>

        <el-table-column prop="name" label="合作类型">
          <template slot-scope="scope">{{ scope.row.cooperate_type_text }}</template>
        </el-table-column>

        <el-table-column prop="name" label="状态">
          <template slot-scope="scope">
            <el-tag type="success" v-if="scope.row.status == 1">正常</el-tag>
            <el-tag type="danger" v-else>禁用</el-tag>
          </template>
        </el-table-column>

        <el-table-column fixed="right" label="操作" width="120">
          <template slot-scope="scope">
            <el-button type="text" size="medium" @click="addEdit(scope.row)">编辑</el-button>
          </template>
        </el-table-column>

      </el-table>
      <pagination v-show="total > 0" :total="total" :page.sync="queryParams.pageNo"
                  :limit.sync="queryParams.pageSize" @pagination="getList('changePage')"/>
      <SubjectEdit v-if="AddSubjectFlag" :AddSubjectFlag="AddSubjectFlag" @NoneDlog="NoneDlog" @AddOk="AddOk"
                   :editID="editID" :types="typeOptions">
      </SubjectEdit>
    </el-card>
  </div>
</template>

<script>
import {MoneyManagementAPI} from '@/api/MoneyManagement/MoneyManagement';
import {processErrors} from "@/utils/errorHandler";
import SubjectEdit from "./edit.vue"

export default {
  components: {
    SubjectEdit
  },
  data() {
    return {
      form: {
        name: ""
      },
      SearchFlag: false,
      queryParams: {
        pageNo: 1,
        pageSize: 10,
        name: "",
        id:'',
        cooperate_type:''
      },
      appidList: [],
      page: {
        pageNo: 1,
        pageSize: 999,
      },

      tableData: [],
      multipleSelection: [],
      dialogVisible: false,
      editID: "",
      // 总条数
      total: 0,
      AddSubjectFlag: false,
      loading: false,
      typeOptions:[  //合作类型列表
        {value: '1', label: '版权商', check: false},
        {value: '2', label: '承制方', check: false}, 
        {value: '3', label: '分销商', check: false},
        {value: '4', label: '发行商', check: false},
        {value: '5', label: '平台方', check: false},
        {value: '6', label: '投资方', check: false},
        {value: '7', label: '服务商', check: false},
        {value: '8', label: '出品方', check: false},
        {value: '9', label: '剧本方', check: false},
      ], 
    };
  },
  created() {
    this.getList()
  },
  methods: {
    getList(type) {
      this.loading = true
      if (type != 'changePage') {
        this.queryParams.pageNo = 1
      }
      let api = MoneyManagementAPI()
      api.getSubjectList(this.queryParams).then(res => {
        if (res.code == 0) {
          this.tableData = res.data.data
          this.total = res.data.totalCount
        } else {
          processErrors(res);
        }
        this.loading = false
      })
    },

    addSearch() {
      if (this.SearchFlag == false) {
        this.SearchFlag = true
      } else {
        this.SearchFlag = false
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    search() {
      this.getList()
    },
    addNoNe() {
      this.queryParams = {
        pageNo: 1,
        pageSize: 10,
        name: "",
        id:'',
        cooperate_type:''
      }
      this.getList()
    },
    addList() {
      this.editID = ""
      this.AddSubjectFlag = true
    },
    NoneDlog() {
      this.AddSubjectFlag = false
    },
    AddOk() {
      this.editID = ""
      this.AddSubjectFlag = false
      this.getList()
    },
    addEdit(row) {
      this.editID = row.id
      this.AddSubjectFlag = true
    },
  },

  mounted() {
    
  },
}
</script>
<style lang='scss' scoped>
.Box {
  & ::v-deep el-card__body {

    padding: 0 !important;

  }
}

.el-card__body {
  padding: 0px !important;
}

.btn_left {
  margin-left: 100px;
}

.div_buttom {
  width: 100%;
  display: flex;
  margin-bottom: 20px;
}
</style>